import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import {
  StyledConfirmMessageBody,
  StyledConfirmSubmitModal,
  StyledConfirmWarningContent,
  StyledExclamationMark
} from './ConfirmSubmitModal.styled'

interface IProps {
  show: boolean
  warningMessage: string
  onHide: () => void
  onSubmit: () => void
}

export const ConfirmSubmitModal: React.FC<IProps> = ({ show, warningMessage, onHide, onSubmit }) => {
  return (
    <StyledConfirmSubmitModal show={show} onHide={onHide} centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Message</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <StyledConfirmMessageBody>
          <StyledExclamationMark>!</StyledExclamationMark>
          <StyledConfirmWarningContent>{warningMessage}</StyledConfirmWarningContent>
        </StyledConfirmMessageBody>
        <div className="mt-3">Are you sure you want to submit this request?</div>
      </Modal.Body>
      <Modal.Footer>
        <div className="btn-group">
          <Button variant="outline-secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSubmit}>
            Submit
          </Button>
        </div>
      </Modal.Footer>
    </StyledConfirmSubmitModal>
  )
}
